<div class="blade-wrapper">
  <div class="blade-header">
    <div  class="blade-tools">
        <app-toolbar [toolbar]="toolbar">
            <ng-template 
              toolbarToolDef="confirm" let-tool>
              <ng-container  *ngIf="tool.hasButtonsToShow">
              <button mat-button
                      data-cy="button"
                      class="datex-button"
                      [disabled]="tool.control.readOnly || tool.control.disabled"
                      [ngStyle]="tool.control.styles.style"
                      [ngClass]="tool.control.styles.classes"
                      [matTooltip]="tool.control.tooltip"
                      matTooltipClass="datex-control-tooltip"
                      (click)="on_confirm_clicked($event)"
                      >
                <div class="button-label">
                  <ng-container *ngIf="tool.control.icon === 'datex-default-spinner'; else showIcon">
                    <div class="button-icon">
                      <i data-cy="button-icon" class="datex-default-spinner"></i>
                    </div>
                  </ng-container>
                  <ng-template #showIcon>
                    <div class="button-icon">
                      <i data-cy="button-icon" class="icon {{tool.control.icon}}"></i>
                    </div>
                  </ng-template>
                  <div data-cy="button-label" class="button-text">{{tool.control.label}}</div>
                </div>
              
              </button>
              </ng-container>
            </ng-template>
            <ng-template 
              toolbarToolDef="cancel" let-tool>
              <ng-container  *ngIf="tool.hasButtonsToShow">
              <button mat-button
                      data-cy="button"
                      class="datex-button"
                      [disabled]="tool.control.readOnly || tool.control.disabled"
                      [ngStyle]="tool.control.styles.style"
                      [ngClass]="tool.control.styles.classes"
                      [matTooltip]="tool.control.tooltip"
                      matTooltipClass="datex-control-tooltip"
                      (click)="on_cancel_clicked($event)"
                      >
                <div class="button-label">
                  <ng-container *ngIf="tool.control.icon === 'datex-default-spinner'; else showIcon">
                    <div class="button-icon">
                      <i data-cy="button-icon" class="datex-default-spinner"></i>
                    </div>
                  </ng-container>
                  <ng-template #showIcon>
                    <div class="button-icon">
                      <i data-cy="button-icon" class="icon {{tool.control.icon}}"></i>
                    </div>
                  </ng-template>
                  <div data-cy="button-label" class="button-text">{{tool.control.label}}</div>
                </div>
              
              </button>
              </ng-container>
            </ng-template>
        </app-toolbar>
    </div>
    <ng-content></ng-content>
  </div>
  <div class="blade-content">
    <div class="datex-form">
      <ng-container *ngIf="initialized ">
        <div [formGroup]="formGroup"
             class="formdata">
                <div data-cy="fieldset-id-newGroup1"
                     *ngIf="!fieldsets.newGroup1.hidden && !fieldsets.newGroup1.removed"
                     class="fieldset-container">
                  <div class="fieldsetsContainer"
                       [ngClass]="{'collapsible': fieldsets.newGroup1.collapsible }">
                    <div *ngIf="!fieldsets.newGroup1.hideTitle"
                         data-cy="fieldset-title"
                         class="fieldsetsTitle"
                         (click)="fieldsets.newGroup1.toggle()">
                      <span class="fieldsetsTitle-text">
                      {{fieldsets.newGroup1.label}}
                      </span>
                      <i data-cy="fieldset-toggle"
                         *ngIf="fieldsets.newGroup1.collapsible"
                         class="icon"
                         [ngClass]="{'icon-ic_fluent_chevron_down_20_filled': !fieldsets.newGroup1.expanded, 'icon-ic_fluent_chevron_up_20_filled': fieldsets.newGroup1.expanded }"></i>
                    </div>
                    <div data-cy="fieldset-group"
                         *ngIf="fieldsets.newGroup1.expanded"
                         class="fieldsetsGroup">
                      <div data-cy="field-id-lookupcode" *ngIf="!fields.lookupcode.hidden && !fields.lookupcode.removed" 
                            class="field-container standard {{fields.lookupcode.invalid ? 'invalid' : ''}} {{fields.lookupcode.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.lookupcode.styles.style"
                            [ngClass]="fields.lookupcode.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.lookupcode.label + (fields.lookupcode.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.lookupcode.label}}<span *ngIf="fields.lookupcode.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <input data-cy="textBox" formControlName="lookupcode"
                                matInput
                                autocomplete="off"
                                spellcheck="false"
                                class="datex-textbox {{ (fields.lookupcode.control.readOnly || fields.lookupcode.control.disabled) ? 'readonly ' : ''}}"
                                placeholder="{{fields.lookupcode.control.placeholder}}"
                                [ngStyle]="fields.lookupcode.control.styles.style"
                                [ngClass]="fields.lookupcode.control.styles.classes"
                                [matTooltip]="fields.lookupcode.control.tooltip"
                                matTooltipClass="datex-control-tooltip"> 
                        <ng-container *ngIf="fields.lookupcode.invalid">
                          <ng-container *ngFor="let error of fields.lookupcode.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-name" *ngIf="!fields.name.hidden && !fields.name.removed" 
                            class="field-container standard {{fields.name.invalid ? 'invalid' : ''}} {{fields.name.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.name.styles.style"
                            [ngClass]="fields.name.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.name.label + (fields.name.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.name.label}}<span *ngIf="fields.name.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <input data-cy="textBox" formControlName="name"
                                matInput
                                autocomplete="off"
                                spellcheck="false"
                                class="datex-textbox {{ (fields.name.control.readOnly || fields.name.control.disabled) ? 'readonly ' : ''}}"
                                placeholder="{{fields.name.control.placeholder}}"
                                [ngStyle]="fields.name.control.styles.style"
                                [ngClass]="fields.name.control.styles.classes"
                                [matTooltip]="fields.name.control.tooltip"
                                matTooltipClass="datex-control-tooltip"> 
                        <ng-container *ngIf="fields.name.invalid">
                          <ng-container *ngFor="let error of fields.name.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-description" *ngIf="!fields.description.hidden && !fields.description.removed" 
                            class="field-container double {{fields.description.invalid ? 'invalid' : ''}} {{fields.description.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.description.styles.style"
                            [ngClass]="fields.description.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.description.label + (fields.description.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.description.label}}<span *ngIf="fields.description.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <input data-cy="textBox" formControlName="description"
                                matInput
                                autocomplete="off"
                                spellcheck="false"
                                class="datex-textbox {{ (fields.description.control.readOnly || fields.description.control.disabled) ? 'readonly ' : ''}}"
                                placeholder="{{fields.description.control.placeholder}}"
                                [ngStyle]="fields.description.control.styles.style"
                                [ngClass]="fields.description.control.styles.classes"
                                [matTooltip]="fields.description.control.tooltip"
                                matTooltipClass="datex-control-tooltip"> 
                        <ng-container *ngIf="fields.description.invalid">
                          <ng-container *ngFor="let error of fields.description.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-owner" *ngIf="!fields.owner.hidden && !fields.owner.removed" 
                            class="field-container standard {{fields.owner.invalid ? 'invalid' : ''}} {{fields.owner.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.owner.styles.style"
                            [ngClass]="fields.owner.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.owner.label + (fields.owner.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.owner.label}}<span *ngIf="fields.owner.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <Owners-owners_dd_single 
                            data-cy="selector"
                            [type]="fields.owner.control.type"
                            formControlName="owner"
                            (displayTextChange)="fields.owner.control.displayText=$event"
                            [placeholder]="fields.owner.control.placeholder"
                            [styles]="fields.owner.control.styles"
                            [tooltip]="fields.owner.control.tooltip"
                          [statusId]="$fields_owner_selector_inParams_statusId"
                          [projectId]="$fields_owner_selector_inParams_projectId"
                        >
                        </Owners-owners_dd_single>
                        <ng-container *ngIf="fields.owner.invalid">
                          <ng-container *ngFor="let error of fields.owner.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-project" *ngIf="!fields.project.hidden && !fields.project.removed" 
                            class="field-container standard {{fields.project.invalid ? 'invalid' : ''}} {{fields.project.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.project.styles.style"
                            [ngClass]="fields.project.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.project.label + (fields.project.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.project.label}}<span *ngIf="fields.project.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <Owners-projects_dd_single 
                            data-cy="selector"
                            [type]="fields.project.control.type"
                            formControlName="project"
                            (displayTextChange)="fields.project.control.displayText=$event"
                            [placeholder]="fields.project.control.placeholder"
                            [styles]="fields.project.control.styles"
                            [tooltip]="fields.project.control.tooltip"
                          [statusId]="$fields_project_selector_inParams_statusId"
                          [ownerId]="$fields_project_selector_inParams_ownerId"
                        >
                        </Owners-projects_dd_single>
                        <ng-container *ngIf="fields.project.invalid">
                          <ng-container *ngFor="let error of fields.project.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-packaging" *ngIf="!fields.packaging.hidden && !fields.packaging.removed" 
                            class="field-container standard {{fields.packaging.invalid ? 'invalid' : ''}} {{fields.packaging.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.packaging.styles.style"
                            [ngClass]="fields.packaging.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.packaging.label + (fields.packaging.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.packaging.label}}<span *ngIf="fields.packaging.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <Materials-material_packagings_dd_single 
                            data-cy="selector"
                            [type]="fields.packaging.control.type"
                            formControlName="packaging"
                            (displayTextChange)="fields.packaging.control.displayText=$event"
                            [placeholder]="fields.packaging.control.placeholder"
                            [styles]="fields.packaging.control.styles"
                            [tooltip]="fields.packaging.control.tooltip"
                        >
                        </Materials-material_packagings_dd_single>
                        <ng-container *ngIf="fields.packaging.invalid">
                          <ng-container *ngFor="let error of fields.packaging.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-upc_code" *ngIf="!fields.upc_code.hidden && !fields.upc_code.removed" 
                            class="field-container standard {{fields.upc_code.invalid ? 'invalid' : ''}} {{fields.upc_code.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.upc_code.styles.style"
                            [ngClass]="fields.upc_code.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.upc_code.label + (fields.upc_code.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.upc_code.label}}<span *ngIf="fields.upc_code.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <input data-cy="textBox" formControlName="upc_code"
                                matInput
                                autocomplete="off"
                                spellcheck="false"
                                class="datex-textbox {{ (fields.upc_code.control.readOnly || fields.upc_code.control.disabled) ? 'readonly ' : ''}}"
                                placeholder="{{fields.upc_code.control.placeholder}}"
                                [ngStyle]="fields.upc_code.control.styles.style"
                                [ngClass]="fields.upc_code.control.styles.classes"
                                [matTooltip]="fields.upc_code.control.tooltip"
                                matTooltipClass="datex-control-tooltip"> 
                        <ng-container *ngIf="fields.upc_code.invalid">
                          <ng-container *ngFor="let error of fields.upc_code.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-material_group" *ngIf="!fields.material_group.hidden && !fields.material_group.removed" 
                            class="field-container standard {{fields.material_group.invalid ? 'invalid' : ''}} {{fields.material_group.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.material_group.styles.style"
                            [ngClass]="fields.material_group.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.material_group.label + (fields.material_group.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.material_group.label}}<span *ngIf="fields.material_group.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <Materials-material_groups_dd_single 
                            data-cy="selector"
                            [type]="fields.material_group.control.type"
                            formControlName="material_group"
                            (displayTextChange)="fields.material_group.control.displayText=$event"
                            [placeholder]="fields.material_group.control.placeholder"
                            [styles]="fields.material_group.control.styles"
                            [tooltip]="fields.material_group.control.tooltip"
                        >
                        </Materials-material_groups_dd_single>
                        <ng-container *ngIf="fields.material_group.invalid">
                          <ng-container *ngFor="let error of fields.material_group.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>            </div>
        
                    <div class="fieldset-details" *ngIf="!fieldsets.newGroup1.expanded">
        
        
                    </div>
                  </div>
                </div>
                <div data-cy="fieldset-id-newGroup2"
                     *ngIf="!fieldsets.newGroup2.hidden && !fieldsets.newGroup2.removed"
                     class="fieldset-container">
                  <div class="fieldsetsContainer"
                       [ngClass]="{'collapsible': fieldsets.newGroup2.collapsible }">
                    <div *ngIf="!fieldsets.newGroup2.hideTitle"
                         data-cy="fieldset-title"
                         class="fieldsetsTitle"
                         (click)="fieldsets.newGroup2.toggle()">
                      <span class="fieldsetsTitle-text">
                      {{fieldsets.newGroup2.label}}
                      </span>
                      <i data-cy="fieldset-toggle"
                         *ngIf="fieldsets.newGroup2.collapsible"
                         class="icon"
                         [ngClass]="{'icon-ic_fluent_chevron_down_20_filled': !fieldsets.newGroup2.expanded, 'icon-ic_fluent_chevron_up_20_filled': fieldsets.newGroup2.expanded }"></i>
                    </div>
                    <div data-cy="fieldset-group"
                         *ngIf="fieldsets.newGroup2.expanded"
                         class="fieldsetsGroup">
                      <div data-cy="field-id-allocation_strategy_workflow" *ngIf="!fields.allocation_strategy_workflow.hidden && !fields.allocation_strategy_workflow.removed" 
                            class="field-container standard {{fields.allocation_strategy_workflow.invalid ? 'invalid' : ''}} {{fields.allocation_strategy_workflow.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.allocation_strategy_workflow.styles.style"
                            [ngClass]="fields.allocation_strategy_workflow.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.allocation_strategy_workflow.label + (fields.allocation_strategy_workflow.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.allocation_strategy_workflow.label}}<span *ngIf="fields.allocation_strategy_workflow.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <Materials-allocation_strategy_workflows_dd_single 
                            data-cy="selector"
                            [type]="fields.allocation_strategy_workflow.control.type"
                            formControlName="allocation_strategy_workflow"
                            (displayTextChange)="fields.allocation_strategy_workflow.control.displayText=$event"
                            [placeholder]="fields.allocation_strategy_workflow.control.placeholder"
                            [styles]="fields.allocation_strategy_workflow.control.styles"
                            [tooltip]="fields.allocation_strategy_workflow.control.tooltip"
                          [is_active]="$fields_allocation_strategy_workflow_selector_inParams_is_active"
                        >
                        </Materials-allocation_strategy_workflows_dd_single>
                        <ng-container *ngIf="fields.allocation_strategy_workflow.invalid">
                          <ng-container *ngFor="let error of fields.allocation_strategy_workflow.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-allocation_strategy_separator" *ngIf="!fields.allocation_strategy_separator.hidden && !fields.allocation_strategy_separator.removed" 
                            class="field-container standard {{fields.allocation_strategy_separator.invalid ? 'invalid' : ''}} {{fields.allocation_strategy_separator.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.allocation_strategy_separator.styles.style"
                            [ngClass]="fields.allocation_strategy_separator.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.allocation_strategy_separator.label + (fields.allocation_strategy_separator.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.allocation_strategy_separator.label}}<span *ngIf="fields.allocation_strategy_separator.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <div data-cy="text" class="datex-text" 
                              [ngStyle]="fields.allocation_strategy_separator.control.styles.style"
                              [ngClass]="fields.allocation_strategy_separator.control.styles.classes"
                              [matTooltip]="fields.allocation_strategy_separator.control.tooltip"
                              matTooltipClass="datex-control-tooltip">{{fields.allocation_strategy_separator.control.text }}</div>
                        <ng-container *ngIf="fields.allocation_strategy_separator.invalid">
                          <ng-container *ngFor="let error of fields.allocation_strategy_separator.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-allocation_strategy" *ngIf="!fields.allocation_strategy.hidden && !fields.allocation_strategy.removed" 
                            class="field-container standard {{fields.allocation_strategy.invalid ? 'invalid' : ''}} {{fields.allocation_strategy.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.allocation_strategy.styles.style"
                            [ngClass]="fields.allocation_strategy.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.allocation_strategy.label + (fields.allocation_strategy.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.allocation_strategy.label}}<span *ngIf="fields.allocation_strategy.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <Materials-allocation_strategies_dd_single 
                            data-cy="selector"
                            [type]="fields.allocation_strategy.control.type"
                            formControlName="allocation_strategy"
                            (displayTextChange)="fields.allocation_strategy.control.displayText=$event"
                            [placeholder]="fields.allocation_strategy.control.placeholder"
                            [styles]="fields.allocation_strategy.control.styles"
                            [tooltip]="fields.allocation_strategy.control.tooltip"
                        >
                        </Materials-allocation_strategies_dd_single>
                        <ng-container *ngIf="fields.allocation_strategy.invalid">
                          <ng-container *ngFor="let error of fields.allocation_strategy.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-allocation_strategy_workflow_separator" *ngIf="!fields.allocation_strategy_workflow_separator.hidden && !fields.allocation_strategy_workflow_separator.removed" 
                            class="field-container standard {{fields.allocation_strategy_workflow_separator.invalid ? 'invalid' : ''}} {{fields.allocation_strategy_workflow_separator.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.allocation_strategy_workflow_separator.styles.style"
                            [ngClass]="fields.allocation_strategy_workflow_separator.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.allocation_strategy_workflow_separator.label + (fields.allocation_strategy_workflow_separator.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.allocation_strategy_workflow_separator.label}}<span *ngIf="fields.allocation_strategy_workflow_separator.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <div data-cy="text" class="datex-text" 
                              [ngStyle]="fields.allocation_strategy_workflow_separator.control.styles.style"
                              [ngClass]="fields.allocation_strategy_workflow_separator.control.styles.classes"
                              [matTooltip]="fields.allocation_strategy_workflow_separator.control.tooltip"
                              matTooltipClass="datex-control-tooltip">{{fields.allocation_strategy_workflow_separator.control.text }}</div>
                        <ng-container *ngIf="fields.allocation_strategy_workflow_separator.invalid">
                          <ng-container *ngFor="let error of fields.allocation_strategy_workflow_separator.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-lot_controlled" *ngIf="!fields.lot_controlled.hidden && !fields.lot_controlled.removed" 
                            class="field-container standard {{fields.lot_controlled.invalid ? 'invalid' : ''}} {{fields.lot_controlled.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.lot_controlled.styles.style"
                            [ngClass]="fields.lot_controlled.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.lot_controlled.label + (fields.lot_controlled.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.lot_controlled.label}}<span *ngIf="fields.lot_controlled.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <mat-slide-toggle data-cy="slideToggle" formControlName="lot_controlled"
                                      color="primary"
                                      class="datex-toggle"
                                      [ngStyle]="fields.lot_controlled.control.styles.style"
                                      [ngClass]="fields.lot_controlled.control.styles.classes"
                                      [matTooltip]="fields.lot_controlled.control.tooltip"
                                      matTooltipClass="datex-control-tooltip">{{fields.lot_controlled.control.label}}</mat-slide-toggle>
                        <ng-container *ngIf="fields.lot_controlled.invalid">
                          <ng-container *ngFor="let error of fields.lot_controlled.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-serial_controlled" *ngIf="!fields.serial_controlled.hidden && !fields.serial_controlled.removed" 
                            class="field-container standard {{fields.serial_controlled.invalid ? 'invalid' : ''}} {{fields.serial_controlled.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.serial_controlled.styles.style"
                            [ngClass]="fields.serial_controlled.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.serial_controlled.label + (fields.serial_controlled.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.serial_controlled.label}}<span *ngIf="fields.serial_controlled.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <mat-slide-toggle data-cy="slideToggle" formControlName="serial_controlled"
                                      color="primary"
                                      class="datex-toggle"
                                      [ngStyle]="fields.serial_controlled.control.styles.style"
                                      [ngClass]="fields.serial_controlled.control.styles.classes"
                                      [matTooltip]="fields.serial_controlled.control.tooltip"
                                      matTooltipClass="datex-control-tooltip">{{fields.serial_controlled.control.label}}</mat-slide-toggle>
                        <ng-container *ngIf="fields.serial_controlled.invalid">
                          <ng-container *ngFor="let error of fields.serial_controlled.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>            </div>
        
                    <div class="fieldset-details" *ngIf="!fieldsets.newGroup2.expanded">
        
        
                    </div>
                  </div>
                </div>
                <div data-cy="fieldset-id-measurements_group"
                     *ngIf="!fieldsets.measurements_group.hidden && !fieldsets.measurements_group.removed"
                     class="fieldset-container">
                  <div class="fieldsetsContainer"
                       [ngClass]="{'collapsible': fieldsets.measurements_group.collapsible }">
                    <div *ngIf="!fieldsets.measurements_group.hideTitle"
                         data-cy="fieldset-title"
                         class="fieldsetsTitle"
                         (click)="fieldsets.measurements_group.toggle()">
                      <span class="fieldsetsTitle-text">
                      {{fieldsets.measurements_group.label}}
                      </span>
                      <i data-cy="fieldset-toggle"
                         *ngIf="fieldsets.measurements_group.collapsible"
                         class="icon"
                         [ngClass]="{'icon-ic_fluent_chevron_down_20_filled': !fieldsets.measurements_group.expanded, 'icon-ic_fluent_chevron_up_20_filled': fieldsets.measurements_group.expanded }"></i>
                    </div>
                    <div data-cy="fieldset-group"
                         *ngIf="fieldsets.measurements_group.expanded"
                         class="fieldsetsGroup">
                      <div data-cy="field-id-decimal_precision" *ngIf="!fields.decimal_precision.hidden && !fields.decimal_precision.removed" 
                            class="field-container standard {{fields.decimal_precision.invalid ? 'invalid' : ''}} {{fields.decimal_precision.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.decimal_precision.styles.style"
                            [ngClass]="fields.decimal_precision.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.decimal_precision.label + (fields.decimal_precision.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.decimal_precision.label}}<span *ngIf="fields.decimal_precision.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <Materials-decimal_precision_single 
                            data-cy="selector"
                            [type]="fields.decimal_precision.control.type"
                            formControlName="decimal_precision"
                            (displayTextChange)="fields.decimal_precision.control.displayText=$event"
                            [placeholder]="fields.decimal_precision.control.placeholder"
                            [styles]="fields.decimal_precision.control.styles"
                            [tooltip]="fields.decimal_precision.control.tooltip"
                        >
                        </Materials-decimal_precision_single>
                        <ng-container *ngIf="fields.decimal_precision.invalid">
                          <ng-container *ngFor="let error of fields.decimal_precision.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-weight_separator" *ngIf="!fields.weight_separator.hidden && !fields.weight_separator.removed" 
                            class="field-container standard {{fields.weight_separator.invalid ? 'invalid' : ''}} {{fields.weight_separator.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.weight_separator.styles.style"
                            [ngClass]="fields.weight_separator.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.weight_separator.label + (fields.weight_separator.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.weight_separator.label}}<span *ngIf="fields.weight_separator.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <div data-cy="text" class="datex-text" 
                              [ngStyle]="fields.weight_separator.control.styles.style"
                              [ngClass]="fields.weight_separator.control.styles.classes"
                              [matTooltip]="fields.weight_separator.control.tooltip"
                              matTooltipClass="datex-control-tooltip">{{fields.weight_separator.control.text }}</div>
                        <ng-container *ngIf="fields.weight_separator.invalid">
                          <ng-container *ngFor="let error of fields.weight_separator.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-fixed_weight" *ngIf="!fields.fixed_weight.hidden && !fields.fixed_weight.removed" 
                            class="field-container standard {{fields.fixed_weight.invalid ? 'invalid' : ''}} {{fields.fixed_weight.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.fixed_weight.styles.style"
                            [ngClass]="fields.fixed_weight.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.fixed_weight.label + (fields.fixed_weight.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.fixed_weight.label}}<span *ngIf="fields.fixed_weight.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <mat-slide-toggle data-cy="slideToggle" formControlName="fixed_weight"
                                      color="primary"
                                      class="datex-toggle"
                                      [ngStyle]="fields.fixed_weight.control.styles.style"
                                      [ngClass]="fields.fixed_weight.control.styles.classes"
                                      [matTooltip]="fields.fixed_weight.control.tooltip"
                                      matTooltipClass="datex-control-tooltip">{{fields.fixed_weight.control.label}}</mat-slide-toggle>
                        <ng-container *ngIf="fields.fixed_weight.invalid">
                          <ng-container *ngFor="let error of fields.fixed_weight.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-weight_toggle_separator" *ngIf="!fields.weight_toggle_separator.hidden && !fields.weight_toggle_separator.removed" 
                            class="field-container standard {{fields.weight_toggle_separator.invalid ? 'invalid' : ''}} {{fields.weight_toggle_separator.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.weight_toggle_separator.styles.style"
                            [ngClass]="fields.weight_toggle_separator.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.weight_toggle_separator.label + (fields.weight_toggle_separator.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.weight_toggle_separator.label}}<span *ngIf="fields.weight_toggle_separator.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <div data-cy="text" class="datex-text" 
                              [ngStyle]="fields.weight_toggle_separator.control.styles.style"
                              [ngClass]="fields.weight_toggle_separator.control.styles.classes"
                              [matTooltip]="fields.weight_toggle_separator.control.tooltip"
                              matTooltipClass="datex-control-tooltip">{{fields.weight_toggle_separator.control.text }}</div>
                        <ng-container *ngIf="fields.weight_toggle_separator.invalid">
                          <ng-container *ngFor="let error of fields.weight_toggle_separator.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-weight" *ngIf="!fields.weight.hidden && !fields.weight.removed" 
                            class="field-container standard {{fields.weight.invalid ? 'invalid' : ''}} {{fields.weight.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.weight.styles.style"
                            [ngClass]="fields.weight.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.weight.label + (fields.weight.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.weight.label}}<span *ngIf="fields.weight.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <input data-cy="numberBox" formControlName="weight"
                                matInput
                                numberBox
                                [format]="fields.weight.control.format"
                                autocomplete="off"
                                spellcheck="false"
                                class="datex-numberbox {{ (fields.weight.control.readOnly || fields.weight.control.disabled) ? 'readonly ' : ''}}"
                                placeholder="{{fields.weight.control.placeholder}}"
                                [ngStyle]="fields.weight.control.styles.style"
                                [ngClass]="fields.weight.control.styles.classes"
                                [matTooltip]="fields.weight.control.tooltip"
                                matTooltipClass="datex-control-tooltip">
                        <ng-container *ngIf="fields.weight.invalid">
                          <ng-container *ngFor="let error of fields.weight.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-shipping_weight" *ngIf="!fields.shipping_weight.hidden && !fields.shipping_weight.removed" 
                            class="field-container standard {{fields.shipping_weight.invalid ? 'invalid' : ''}} {{fields.shipping_weight.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.shipping_weight.styles.style"
                            [ngClass]="fields.shipping_weight.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.shipping_weight.label + (fields.shipping_weight.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.shipping_weight.label}}<span *ngIf="fields.shipping_weight.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <input data-cy="numberBox" formControlName="shipping_weight"
                                matInput
                                numberBox
                                [format]="fields.shipping_weight.control.format"
                                autocomplete="off"
                                spellcheck="false"
                                class="datex-numberbox {{ (fields.shipping_weight.control.readOnly || fields.shipping_weight.control.disabled) ? 'readonly ' : ''}}"
                                placeholder="{{fields.shipping_weight.control.placeholder}}"
                                [ngStyle]="fields.shipping_weight.control.styles.style"
                                [ngClass]="fields.shipping_weight.control.styles.classes"
                                [matTooltip]="fields.shipping_weight.control.tooltip"
                                matTooltipClass="datex-control-tooltip">
                        <ng-container *ngIf="fields.shipping_weight.invalid">
                          <ng-container *ngFor="let error of fields.shipping_weight.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-weight_uom" *ngIf="!fields.weight_uom.hidden && !fields.weight_uom.removed" 
                            class="field-container standard {{fields.weight_uom.invalid ? 'invalid' : ''}} {{fields.weight_uom.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.weight_uom.styles.style"
                            [ngClass]="fields.weight_uom.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.weight_uom.label + (fields.weight_uom.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.weight_uom.label}}<span *ngIf="fields.weight_uom.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <Materials-measurement_units_dd_single 
                            data-cy="selector"
                            [type]="fields.weight_uom.control.type"
                            formControlName="weight_uom"
                            (displayTextChange)="fields.weight_uom.control.displayText=$event"
                            [placeholder]="fields.weight_uom.control.placeholder"
                            [styles]="fields.weight_uom.control.styles"
                            [tooltip]="fields.weight_uom.control.tooltip"
                          [typeId]="$fields_weight_uom_selector_inParams_typeId"
                        >
                        </Materials-measurement_units_dd_single>
                        <ng-container *ngIf="fields.weight_uom.invalid">
                          <ng-container *ngFor="let error of fields.weight_uom.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-volume_separator" *ngIf="!fields.volume_separator.hidden && !fields.volume_separator.removed" 
                            class="field-container standard {{fields.volume_separator.invalid ? 'invalid' : ''}} {{fields.volume_separator.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.volume_separator.styles.style"
                            [ngClass]="fields.volume_separator.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.volume_separator.label + (fields.volume_separator.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.volume_separator.label}}<span *ngIf="fields.volume_separator.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <div data-cy="text" class="datex-text" 
                              [ngStyle]="fields.volume_separator.control.styles.style"
                              [ngClass]="fields.volume_separator.control.styles.classes"
                              [matTooltip]="fields.volume_separator.control.tooltip"
                              matTooltipClass="datex-control-tooltip">{{fields.volume_separator.control.text }}</div>
                        <ng-container *ngIf="fields.volume_separator.invalid">
                          <ng-container *ngFor="let error of fields.volume_separator.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-fixed_volume" *ngIf="!fields.fixed_volume.hidden && !fields.fixed_volume.removed" 
                            class="field-container standard {{fields.fixed_volume.invalid ? 'invalid' : ''}} {{fields.fixed_volume.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.fixed_volume.styles.style"
                            [ngClass]="fields.fixed_volume.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.fixed_volume.label + (fields.fixed_volume.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.fixed_volume.label}}<span *ngIf="fields.fixed_volume.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <mat-slide-toggle data-cy="slideToggle" formControlName="fixed_volume"
                                      color="primary"
                                      class="datex-toggle"
                                      [ngStyle]="fields.fixed_volume.control.styles.style"
                                      [ngClass]="fields.fixed_volume.control.styles.classes"
                                      [matTooltip]="fields.fixed_volume.control.tooltip"
                                      matTooltipClass="datex-control-tooltip">{{fields.fixed_volume.control.label}}</mat-slide-toggle>
                        <ng-container *ngIf="fields.fixed_volume.invalid">
                          <ng-container *ngFor="let error of fields.fixed_volume.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-volume_toggle_separator" *ngIf="!fields.volume_toggle_separator.hidden && !fields.volume_toggle_separator.removed" 
                            class="field-container standard {{fields.volume_toggle_separator.invalid ? 'invalid' : ''}} {{fields.volume_toggle_separator.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.volume_toggle_separator.styles.style"
                            [ngClass]="fields.volume_toggle_separator.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.volume_toggle_separator.label + (fields.volume_toggle_separator.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.volume_toggle_separator.label}}<span *ngIf="fields.volume_toggle_separator.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <div data-cy="text" class="datex-text" 
                              [ngStyle]="fields.volume_toggle_separator.control.styles.style"
                              [ngClass]="fields.volume_toggle_separator.control.styles.classes"
                              [matTooltip]="fields.volume_toggle_separator.control.tooltip"
                              matTooltipClass="datex-control-tooltip">{{fields.volume_toggle_separator.control.text }}</div>
                        <ng-container *ngIf="fields.volume_toggle_separator.invalid">
                          <ng-container *ngFor="let error of fields.volume_toggle_separator.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-volume" *ngIf="!fields.volume.hidden && !fields.volume.removed" 
                            class="field-container standard {{fields.volume.invalid ? 'invalid' : ''}} {{fields.volume.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.volume.styles.style"
                            [ngClass]="fields.volume.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.volume.label + (fields.volume.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.volume.label}}<span *ngIf="fields.volume.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <input data-cy="numberBox" formControlName="volume"
                                matInput
                                numberBox
                                [format]="fields.volume.control.format"
                                autocomplete="off"
                                spellcheck="false"
                                class="datex-numberbox {{ (fields.volume.control.readOnly || fields.volume.control.disabled) ? 'readonly ' : ''}}"
                                placeholder="{{fields.volume.control.placeholder}}"
                                [ngStyle]="fields.volume.control.styles.style"
                                [ngClass]="fields.volume.control.styles.classes"
                                [matTooltip]="fields.volume.control.tooltip"
                                matTooltipClass="datex-control-tooltip">
                        <ng-container *ngIf="fields.volume.invalid">
                          <ng-container *ngFor="let error of fields.volume.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-shipping_volume" *ngIf="!fields.shipping_volume.hidden && !fields.shipping_volume.removed" 
                            class="field-container standard {{fields.shipping_volume.invalid ? 'invalid' : ''}} {{fields.shipping_volume.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.shipping_volume.styles.style"
                            [ngClass]="fields.shipping_volume.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.shipping_volume.label + (fields.shipping_volume.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.shipping_volume.label}}<span *ngIf="fields.shipping_volume.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <input data-cy="numberBox" formControlName="shipping_volume"
                                matInput
                                numberBox
                                [format]="fields.shipping_volume.control.format"
                                autocomplete="off"
                                spellcheck="false"
                                class="datex-numberbox {{ (fields.shipping_volume.control.readOnly || fields.shipping_volume.control.disabled) ? 'readonly ' : ''}}"
                                placeholder="{{fields.shipping_volume.control.placeholder}}"
                                [ngStyle]="fields.shipping_volume.control.styles.style"
                                [ngClass]="fields.shipping_volume.control.styles.classes"
                                [matTooltip]="fields.shipping_volume.control.tooltip"
                                matTooltipClass="datex-control-tooltip">
                        <ng-container *ngIf="fields.shipping_volume.invalid">
                          <ng-container *ngFor="let error of fields.shipping_volume.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-volume_uom" *ngIf="!fields.volume_uom.hidden && !fields.volume_uom.removed" 
                            class="field-container standard {{fields.volume_uom.invalid ? 'invalid' : ''}} {{fields.volume_uom.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.volume_uom.styles.style"
                            [ngClass]="fields.volume_uom.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.volume_uom.label + (fields.volume_uom.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.volume_uom.label}}<span *ngIf="fields.volume_uom.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <Materials-measurement_units_dd_single 
                            data-cy="selector"
                            [type]="fields.volume_uom.control.type"
                            formControlName="volume_uom"
                            (displayTextChange)="fields.volume_uom.control.displayText=$event"
                            [placeholder]="fields.volume_uom.control.placeholder"
                            [styles]="fields.volume_uom.control.styles"
                            [tooltip]="fields.volume_uom.control.tooltip"
                          [typeId]="$fields_volume_uom_selector_inParams_typeId"
                        >
                        </Materials-measurement_units_dd_single>
                        <ng-container *ngIf="fields.volume_uom.invalid">
                          <ng-container *ngFor="let error of fields.volume_uom.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-dimensions_separator" *ngIf="!fields.dimensions_separator.hidden && !fields.dimensions_separator.removed" 
                            class="field-container standard {{fields.dimensions_separator.invalid ? 'invalid' : ''}} {{fields.dimensions_separator.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.dimensions_separator.styles.style"
                            [ngClass]="fields.dimensions_separator.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.dimensions_separator.label + (fields.dimensions_separator.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.dimensions_separator.label}}<span *ngIf="fields.dimensions_separator.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <div data-cy="text" class="datex-text" 
                              [ngStyle]="fields.dimensions_separator.control.styles.style"
                              [ngClass]="fields.dimensions_separator.control.styles.classes"
                              [matTooltip]="fields.dimensions_separator.control.tooltip"
                              matTooltipClass="datex-control-tooltip">{{fields.dimensions_separator.control.text }}</div>
                        <ng-container *ngIf="fields.dimensions_separator.invalid">
                          <ng-container *ngFor="let error of fields.dimensions_separator.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-fixed_dimensions" *ngIf="!fields.fixed_dimensions.hidden && !fields.fixed_dimensions.removed" 
                            class="field-container standard {{fields.fixed_dimensions.invalid ? 'invalid' : ''}} {{fields.fixed_dimensions.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.fixed_dimensions.styles.style"
                            [ngClass]="fields.fixed_dimensions.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.fixed_dimensions.label + (fields.fixed_dimensions.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.fixed_dimensions.label}}<span *ngIf="fields.fixed_dimensions.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <mat-slide-toggle data-cy="slideToggle" formControlName="fixed_dimensions"
                                      color="primary"
                                      class="datex-toggle"
                                      [ngStyle]="fields.fixed_dimensions.control.styles.style"
                                      [ngClass]="fields.fixed_dimensions.control.styles.classes"
                                      [matTooltip]="fields.fixed_dimensions.control.tooltip"
                                      matTooltipClass="datex-control-tooltip">{{fields.fixed_dimensions.control.label}}</mat-slide-toggle>
                        <ng-container *ngIf="fields.fixed_dimensions.invalid">
                          <ng-container *ngFor="let error of fields.fixed_dimensions.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-dimensions_toggle_separator" *ngIf="!fields.dimensions_toggle_separator.hidden && !fields.dimensions_toggle_separator.removed" 
                            class="field-container standard {{fields.dimensions_toggle_separator.invalid ? 'invalid' : ''}} {{fields.dimensions_toggle_separator.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.dimensions_toggle_separator.styles.style"
                            [ngClass]="fields.dimensions_toggle_separator.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.dimensions_toggle_separator.label + (fields.dimensions_toggle_separator.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.dimensions_toggle_separator.label}}<span *ngIf="fields.dimensions_toggle_separator.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <div data-cy="text" class="datex-text" 
                              [ngStyle]="fields.dimensions_toggle_separator.control.styles.style"
                              [ngClass]="fields.dimensions_toggle_separator.control.styles.classes"
                              [matTooltip]="fields.dimensions_toggle_separator.control.tooltip"
                              matTooltipClass="datex-control-tooltip">{{fields.dimensions_toggle_separator.control.text }}</div>
                        <ng-container *ngIf="fields.dimensions_toggle_separator.invalid">
                          <ng-container *ngFor="let error of fields.dimensions_toggle_separator.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-length" *ngIf="!fields.length.hidden && !fields.length.removed" 
                            class="field-container standard {{fields.length.invalid ? 'invalid' : ''}} {{fields.length.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.length.styles.style"
                            [ngClass]="fields.length.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.length.label + (fields.length.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.length.label}}<span *ngIf="fields.length.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <input data-cy="numberBox" formControlName="length"
                                matInput
                                numberBox
                                [format]="fields.length.control.format"
                                autocomplete="off"
                                spellcheck="false"
                                class="datex-numberbox {{ (fields.length.control.readOnly || fields.length.control.disabled) ? 'readonly ' : ''}}"
                                placeholder="{{fields.length.control.placeholder}}"
                                [ngStyle]="fields.length.control.styles.style"
                                [ngClass]="fields.length.control.styles.classes"
                                [matTooltip]="fields.length.control.tooltip"
                                matTooltipClass="datex-control-tooltip">
                        <ng-container *ngIf="fields.length.invalid">
                          <ng-container *ngFor="let error of fields.length.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-width" *ngIf="!fields.width.hidden && !fields.width.removed" 
                            class="field-container standard {{fields.width.invalid ? 'invalid' : ''}} {{fields.width.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.width.styles.style"
                            [ngClass]="fields.width.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.width.label + (fields.width.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.width.label}}<span *ngIf="fields.width.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <input data-cy="numberBox" formControlName="width"
                                matInput
                                numberBox
                                [format]="fields.width.control.format"
                                autocomplete="off"
                                spellcheck="false"
                                class="datex-numberbox {{ (fields.width.control.readOnly || fields.width.control.disabled) ? 'readonly ' : ''}}"
                                placeholder="{{fields.width.control.placeholder}}"
                                [ngStyle]="fields.width.control.styles.style"
                                [ngClass]="fields.width.control.styles.classes"
                                [matTooltip]="fields.width.control.tooltip"
                                matTooltipClass="datex-control-tooltip">
                        <ng-container *ngIf="fields.width.invalid">
                          <ng-container *ngFor="let error of fields.width.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-height" *ngIf="!fields.height.hidden && !fields.height.removed" 
                            class="field-container standard {{fields.height.invalid ? 'invalid' : ''}} {{fields.height.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.height.styles.style"
                            [ngClass]="fields.height.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.height.label + (fields.height.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.height.label}}<span *ngIf="fields.height.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <input data-cy="numberBox" formControlName="height"
                                matInput
                                numberBox
                                [format]="fields.height.control.format"
                                autocomplete="off"
                                spellcheck="false"
                                class="datex-numberbox {{ (fields.height.control.readOnly || fields.height.control.disabled) ? 'readonly ' : ''}}"
                                placeholder="{{fields.height.control.placeholder}}"
                                [ngStyle]="fields.height.control.styles.style"
                                [ngClass]="fields.height.control.styles.classes"
                                [matTooltip]="fields.height.control.tooltip"
                                matTooltipClass="datex-control-tooltip">
                        <ng-container *ngIf="fields.height.invalid">
                          <ng-container *ngFor="let error of fields.height.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-dimension_uom" *ngIf="!fields.dimension_uom.hidden && !fields.dimension_uom.removed" 
                            class="field-container standard {{fields.dimension_uom.invalid ? 'invalid' : ''}} {{fields.dimension_uom.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.dimension_uom.styles.style"
                            [ngClass]="fields.dimension_uom.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.dimension_uom.label + (fields.dimension_uom.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.dimension_uom.label}}<span *ngIf="fields.dimension_uom.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <Materials-measurement_units_dd_single 
                            data-cy="selector"
                            [type]="fields.dimension_uom.control.type"
                            formControlName="dimension_uom"
                            (displayTextChange)="fields.dimension_uom.control.displayText=$event"
                            [placeholder]="fields.dimension_uom.control.placeholder"
                            [styles]="fields.dimension_uom.control.styles"
                            [tooltip]="fields.dimension_uom.control.tooltip"
                          [typeId]="$fields_dimension_uom_selector_inParams_typeId"
                        >
                        </Materials-measurement_units_dd_single>
                        <ng-container *ngIf="fields.dimension_uom.invalid">
                          <ng-container *ngFor="let error of fields.dimension_uom.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>            </div>
        
                    <div class="fieldset-details" *ngIf="!fieldsets.measurements_group.expanded">
        
        
                    </div>
                  </div>
                </div>
                <div data-cy="fieldset-id-storage_rules_group"
                     *ngIf="!fieldsets.storage_rules_group.hidden && !fieldsets.storage_rules_group.removed"
                     class="fieldset-container">
                  <div class="fieldsetsContainer"
                       [ngClass]="{'collapsible': fieldsets.storage_rules_group.collapsible }">
                    <div *ngIf="!fieldsets.storage_rules_group.hideTitle"
                         data-cy="fieldset-title"
                         class="fieldsetsTitle"
                         (click)="fieldsets.storage_rules_group.toggle()">
                      <span class="fieldsetsTitle-text">
                      {{fieldsets.storage_rules_group.label}}
                      </span>
                      <i data-cy="fieldset-toggle"
                         *ngIf="fieldsets.storage_rules_group.collapsible"
                         class="icon"
                         [ngClass]="{'icon-ic_fluent_chevron_down_20_filled': !fieldsets.storage_rules_group.expanded, 'icon-ic_fluent_chevron_up_20_filled': fieldsets.storage_rules_group.expanded }"></i>
                    </div>
                    <div data-cy="fieldset-group"
                         *ngIf="fieldsets.storage_rules_group.expanded"
                         class="fieldsetsGroup">
                      <div data-cy="field-id-pallet_high" *ngIf="!fields.pallet_high.hidden && !fields.pallet_high.removed" 
                            class="field-container standard {{fields.pallet_high.invalid ? 'invalid' : ''}} {{fields.pallet_high.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.pallet_high.styles.style"
                            [ngClass]="fields.pallet_high.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.pallet_high.label + (fields.pallet_high.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.pallet_high.label}}<span *ngIf="fields.pallet_high.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <input data-cy="numberBox" formControlName="pallet_high"
                                matInput
                                numberBox
                                [format]="fields.pallet_high.control.format"
                                autocomplete="off"
                                spellcheck="false"
                                class="datex-numberbox {{ (fields.pallet_high.control.readOnly || fields.pallet_high.control.disabled) ? 'readonly ' : ''}}"
                                placeholder="{{fields.pallet_high.control.placeholder}}"
                                [ngStyle]="fields.pallet_high.control.styles.style"
                                [ngClass]="fields.pallet_high.control.styles.classes"
                                [matTooltip]="fields.pallet_high.control.tooltip"
                                matTooltipClass="datex-control-tooltip">
                        <ng-container *ngIf="fields.pallet_high.invalid">
                          <ng-container *ngFor="let error of fields.pallet_high.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-pallet_tie" *ngIf="!fields.pallet_tie.hidden && !fields.pallet_tie.removed" 
                            class="field-container standard {{fields.pallet_tie.invalid ? 'invalid' : ''}} {{fields.pallet_tie.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.pallet_tie.styles.style"
                            [ngClass]="fields.pallet_tie.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.pallet_tie.label + (fields.pallet_tie.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.pallet_tie.label}}<span *ngIf="fields.pallet_tie.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <input data-cy="numberBox" formControlName="pallet_tie"
                                matInput
                                numberBox
                                [format]="fields.pallet_tie.control.format"
                                autocomplete="off"
                                spellcheck="false"
                                class="datex-numberbox {{ (fields.pallet_tie.control.readOnly || fields.pallet_tie.control.disabled) ? 'readonly ' : ''}}"
                                placeholder="{{fields.pallet_tie.control.placeholder}}"
                                [ngStyle]="fields.pallet_tie.control.styles.style"
                                [ngClass]="fields.pallet_tie.control.styles.classes"
                                [matTooltip]="fields.pallet_tie.control.tooltip"
                                matTooltipClass="datex-control-tooltip">
                        <ng-container *ngIf="fields.pallet_tie.invalid">
                          <ng-container *ngFor="let error of fields.pallet_tie.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-shelf_life_span" *ngIf="!fields.shelf_life_span.hidden && !fields.shelf_life_span.removed" 
                            class="field-container standard {{fields.shelf_life_span.invalid ? 'invalid' : ''}} {{fields.shelf_life_span.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.shelf_life_span.styles.style"
                            [ngClass]="fields.shelf_life_span.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.shelf_life_span.label + (fields.shelf_life_span.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.shelf_life_span.label}}<span *ngIf="fields.shelf_life_span.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <input data-cy="numberBox" formControlName="shelf_life_span"
                                matInput
                                numberBox
                                [format]="fields.shelf_life_span.control.format"
                                autocomplete="off"
                                spellcheck="false"
                                class="datex-numberbox {{ (fields.shelf_life_span.control.readOnly || fields.shelf_life_span.control.disabled) ? 'readonly ' : ''}}"
                                placeholder="{{fields.shelf_life_span.control.placeholder}}"
                                [ngStyle]="fields.shelf_life_span.control.styles.style"
                                [ngClass]="fields.shelf_life_span.control.styles.classes"
                                [matTooltip]="fields.shelf_life_span.control.tooltip"
                                matTooltipClass="datex-control-tooltip">
                        <ng-container *ngIf="fields.shelf_life_span.invalid">
                          <ng-container *ngFor="let error of fields.shelf_life_span.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>              <div data-cy="field-id-storage_category_rule" *ngIf="!fields.storage_category_rule.hidden && !fields.storage_category_rule.removed" 
                            class="field-container standard {{fields.storage_category_rule.invalid ? 'invalid' : ''}} {{fields.storage_category_rule.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.storage_category_rule.styles.style"
                            [ngClass]="fields.storage_category_rule.styles.classes">
                        <div class="label-container"
                             [matTooltip]="fields.storage_category_rule.label + (fields.storage_category_rule.required ? ' (required)' : '')"
                             matTooltipClass="datex-control-tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.storage_category_rule.label}}<span *ngIf="fields.storage_category_rule.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <Materials-storage_category_rules_dd_single 
                            data-cy="selector"
                            [type]="fields.storage_category_rule.control.type"
                            formControlName="storage_category_rule"
                            (displayTextChange)="fields.storage_category_rule.control.displayText=$event"
                            [placeholder]="fields.storage_category_rule.control.placeholder"
                            [styles]="fields.storage_category_rule.control.styles"
                            [tooltip]="fields.storage_category_rule.control.tooltip"
                        >
                        </Materials-storage_category_rules_dd_single>
                        <ng-container *ngIf="fields.storage_category_rule.invalid">
                          <ng-container *ngFor="let error of fields.storage_category_rule.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>            </div>
        
                    <div class="fieldset-details" *ngIf="!fieldsets.storage_rules_group.expanded">
        
        
                    </div>
                  </div>
                </div>
              </div>
      </ng-container>

    </div>
  </div>
</div>